import {
  WellHouseSmall,
  WellHouseTitleWrapper,
  SuccessCard,
  SuccessMessage,
  ReturnButton,
} from "../styles/EnableMarketPlace";

import { useTranslation } from "react-i18next";
import Sucessconnections from "@assets/svg/Sucessconnections.svg?react";
import { useNavigate, useParams } from "react-router-dom";

const AppLinkedSuccess = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <>
      {/* header */}
      <WellHouseTitleWrapper>
        <WellHouseSmall />
        {t("AppMarket.WellHouseTitle")}
      </WellHouseTitleWrapper>

      {/* card content */}
      <SuccessCard>
        <Sucessconnections style={{ width: "74px", height: "74px" }} />
        <SuccessMessage>{t("AppMarket.connectedSuccessfully")}</SuccessMessage>
        <ReturnButton onClick={() => navigate(`/apps-Details/${id}`)}>
          {t("AppMarket.backToAppMarket")}
        </ReturnButton>
      </SuccessCard>
    </>
  );
};

export default AppLinkedSuccess;
